import React from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import { RpModal } from 'portal-modules/common/components/modals'

import styled from '@emotion/styled'

const StyledLabel = styled('label')`
  color: ${({ theme }) => theme.gray.dark};
  display: block;
  font-size: 16px;
  font-weight: bold;
`

const StyledHr = styled('hr')`
  color: ${({ theme }) => theme.gray.light};
  margin: 8px -24px 24px -24px;
`

const StyledButtonsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 32px 0 16px;

  button {
    @media screen and (min-width: 300px) {
      width: auto;
    }

    :last-child {
      margin-left: 8px;
    }
  }
`

const StyledNote = styled('div')`
  width: 100%;
  max-height: 300px;
  overflow: auto;
`

const RejectionNote = ({ rejection_note, title, ...props }) => (
  <RpModal {...props}>
    <StyledLabel>{title}</StyledLabel>
    <StyledHr />
    <StyledNote>{rejection_note}</StyledNote>
    <StyledButtonsWrapper>
      <Button size='large' appearance='primary' onClick={props.onClose}>
        {__('Close')}
      </Button>
    </StyledButtonsWrapper>
  </RpModal>
)

RejectionNote.propTypes = {
  rejection_note: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
}

export default RejectionNote
